module.exports = __webpack_public_path__ + "media/images/emblems/Furna_wappen-835806065e463f1d09d573e0a927b857.svg";